import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';
import { useLoadRangeAtStartTs } from '../range/useLoadRangeAtStartTs';

/**
 * Hook to move the stream forward.
 */

export function useGoForward() {
  const range = useStreamUserDefinedRange();
  const loadStream = useLoadRangeAtStartTs();

  return (ms: number) => {
    return loadStream(range.from + ms);
  };
}
